export const EntryPermissionValid = () => {
  const currentTimestamp: any = Date.now();
  const day: number = 60 * 60 * 24 * 1000;

  if (localStorage.getItem("allowEntry") === null) {
    return false;
  }

  if (currentTimestamp < currentTimestamp + day) {
    return true;
  } else {
    return false;
  }
};